import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

const getOrderDetails = async (orderId) => {
  const res = await axiosInstance.get(API_ROUTES.OrderDetails.replace(':order_id', orderId))
  return res.data
}

export default getOrderDetails
